import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { APIS, SF_COMN_CD_MGMT_MSTR_INFO, URLS } from "./services/PtliComnCdAppService";

/*
 * Modifying Common Code
 * !== 공통 코드 수정 ==!
 */
export const PTLI0404004S = (props: any) => {
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0061", "auth_ecti0001", "auth_ecti0009"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { comnCd } = useParams();
    const [params] = useSearchParams();
    const bsopClsfCd = params.get("bsopClsfCd");

    const form = {
        comnCdMgmtMstrInfo: useForm({
            defaultSchema: SF_COMN_CD_MGMT_MSTR_INFO,
        }),
    };

    const fetch = {
        // Check common code information !== 공통 코드 정보 조회 ==!
        getComnCdMstrInfo: useFetch({
            api: () => APIS.getComnCdMstrInfo(comnCd),
            enabled: !!comnCd,
            onSuccess: (data) => {
                const comnCdMgmtMstrInfo = data.comnCdMstr.content;
                form.comnCdMgmtMstrInfo.setValues(comnCdMgmtMstrInfo);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
        // Save Common Code !== 공통 코드 저장 ==!
        saveComnCdMstr: useFetch({
            api: (data: any) => APIS.saveComnCdMstr(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(URLS.ptli0404003q + "/" + form.comnCdMgmtMstrInfo.getValue("comnCd"));
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        // Save Common Code !== 공통 코드 저장 ==!
        saveComnCdMstr: () => {
            if (!comnUtils.isEmpty(form.comnCdMgmtMstrInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.comnCdMgmtMstrInfo.handleSubmit(
                () => {
                    const data = form.comnCdMgmtMstrInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveComnCdMstr.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        fetch.getComnCdMstrInfo.fetch();
        form.comnCdMgmtMstrInfo.setSchema("comnCd", { edit: false });

        if (bsopClsfCd) {
            form.comnCdMgmtMstrInfo.setValue("bsopClsfCd", bsopClsfCd);
            form.comnCdMgmtMstrInfo.setSchema("bsopClsfCd", { readOnly: true, disabled: true });
        }
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCd} />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.bsopClsfCd} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmEn} />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmTz} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmKo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdDataLenVal} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.useYn} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section>
                        <Layout>
                            <Layout.Left>
                                <Layout.Button
                                    role={"list"}
                                    onClick={() => {
                                        if (bsopClsfCd) {
                                            navigate(`${URLS.ptli0404001q}?bsopClsfCd=${bsopClsfCd}`);
                                        } else {
                                            navigate(URLS.ptli0404001q);
                                        }
                                    }}
                                />
                            </Layout.Left>
                            <Layout.Right>
                                <Layout.Button
                                    role="cancel"
                                    onClick={() => {
                                        if (bsopClsfCd) {
                                            navigate(`${URLS.ptli0404003q}/${comnCd}?bsopClsfCd=${bsopClsfCd}`);
                                        } else {
                                            navigate(`${URLS.ptli0404003q}/${comnCd}`);
                                        }
                                    }}
                                ></Layout.Button>
                                <Layout.Button role={"save"} onClick={handler.saveComnCdMstr} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
